module.exports = __webpack_public_path__ + "img/cloud-sync.50c79bba.svg";